export default "__VITE_ASSET__ULqrsaJy__"